import { styled } from '@mui/material';

import { AvatarWrapper } from '../../../../../../../components';

export const AvatarPatientProfile = styled( AvatarWrapper )(() => ({
  width: '120px',
  height: '120px',
}));
